import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  ssDialogService,
  vmDataService,
} from 'app/services';
import controller from './edit-soc-comment-dialog.controller';
import template from './edit-soc-comment-dialog.html';
import commentTextMessagesTpl from './messages/comment.text.messages.html';

class dialogService {
  getOptions($event, { productSocComment, addCallback, editCallback }) {
    return {
      controller,
      controllerAs: 'editSocCommentDialogVM',
      locals: {
        productSocComment,
        addCallback,
        editCallback
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.vendorManagement.editSOCCommentDialog', [
  constants,
  loaderService,
  ssDialogService,
  vmDataService,
])
  .service('editSOCCommentDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('comment.text.messages.html', commentTextMessagesTpl);
  })
  .name;
